import React from 'react';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles({
    contentHeader: {
        display: 'flex',
        flexDirection: 'column',
        fontWeight: 'normal',
        fontSize: 'smaller',
    },
    sectionSubTitle: {
        minWidth: '180px',
        margin: '0',
    },
});

// Заголовок с именем пользователя для "стандартных" страниц.
const UserTitle = (props: any) => {
    const {isAdmin, defaultText} = props;
    const styles = useStyles();
    const currentUser = {
        id: sessionStorage.getItem('currentUserId'),
        inn: sessionStorage.getItem('currentUserInn'),
        name: sessionStorage.getItem('currentUserName'),
        address: sessionStorage.getItem('currentUserAddress'),
    };
    if (!isAdmin || !currentUser.inn) {
        if (defaultText) {
            return (
                <div className={styles.contentHeader}>
                    <div className={styles.sectionSubTitle}>
                        <span className="name">{defaultText}</span>
                    </div>
                </div>
            );
        }
        return null;
    }
    // алгоритм: Для админа выводить параметры пользователя.
    // алгоритм: ИНН должен быть всегда.
    return (
        <div className={styles.contentHeader}>
            <div className={styles.sectionSubTitle}>
                {currentUser.name && (
                    <span className="name" title="Параметры пользователя: Имя">
                        {currentUser.name}
                    </span>
                )}
                &nbsp; (
                <span className="inn" title="Параметры пользователя: ИНН">
                    {currentUser.inn}
                </span>
                )
            </div>
        </div>
    );
    // алгоритм: Адрес пользователя.
    // Показывать - не показывать?
    // {currentUser.address && <span><span>: </span><span className="address" title="Параметры пользователя: Адресс">{currentUser.address}</span></span>}
};

export default UserTitle;
